<template>
  <div class="qw-archive-app-select">
    <span class="qw-archive-app-select__label">接入方</span>
    <el-select
      :value="value ? value.appId : ''"
      size="small"
      filterable
      placeholder="选择接入方后可查询"
      style="width: 260px"
      @change="handleChange"
    >
      <el-option
        v-for="app in appOptions"
        :key="app.id"
        :label="app.remark ? `${app.appId}（${app.remark}）` : app.appId"
        :value="app.appId"
      />
    </el-select>
    <el-tooltip v-if="appOptions.length === 0 && !loading" content="仅显示启用状态的接入方，请先到「接入方管理」新增并启用" placement="bottom">
      <i class="el-icon-warning-outline qw-archive-app-select__tip"></i>
    </el-tooltip>
  </div>
</template>

<script>
import { getAppList } from '@/api/appList'
import { getArchiveApp, setArchiveApp } from '@/utils/auth'

// 存档查询页共用的「接入方选择器」
// /qw-archive/** 接口需要携带接入方 appId/appSecret 鉴权（后端 QiWeiAuthWebConfig 拦截），
// 选择结果通过 sessionStorage 在客户群/消息/存档状态三个页面间共享
export default {
    name: 'ArchiveAppSelect',
    props: {
        // 当前选中的接入方对象（含 appId/appSecret）
        value: { type: Object, default: null }
    },
    data () {
        return {
            appList: [],
            loading: false
        }
    },
    computed: {
        // 只展示启用状态的接入方（停用的接入方凭据已无法通过后端校验）
        appOptions () {
            return this.appList.filter(app => app.status === 1)
        }
    },
    created () {
        this.fetchAppList()
    },
    methods: {
        async fetchAppList () {
            this.loading = true
            try {
                const res = await getAppList()
                this.appList = res.data || []
                this.restoreSelection()
            } catch (error) {
                // 错误提示已由 request 拦截器统一弹出
            } finally {
                this.loading = false
            }
        },
        // 从 sessionStorage 恢复上次选择（刷新页面不丢失）
        restoreSelection () {
            if (this.value) return
            const cached = getArchiveApp()
            if (cached && this.appOptions.some(app => app.appId === cached.appId)) {
                this.$emit('input', cached)
            }
        },
        handleChange (appId) {
            const app = this.appOptions.find(item => item.appId === appId) || null
            setArchiveApp(app)
            this.$emit('input', app)
            this.$emit('change', app)
        }
    }
}
</script>

<style lang="scss" scoped>
.qw-archive-app-select {
    display: flex;
    align-items: center;
    gap: 10px;
}

.qw-archive-app-select__label {
    font-size: 13px;
    font-weight: 600;
    color: var(--qw-text-secondary);
}

.qw-archive-app-select__tip {
    color: var(--qw-warning);
    font-size: 16px;
}
</style>
